import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Footer } from '@ahmdigital/ui';
import { useRouter } from 'next/router';

import determineFooterProps from './utils/determine-footer-props';
import footerActionCreators from '../../actions/footer';
import ServerSafeVisibilitySensor from './components/server-safe-visibility-sensor';

type FooterProps = {
  actions: {
    footer: {
      setVisibility: (isVisible: any) => void;
    };
  };
};

const FooterWithStaticProps = ({ actions }: FooterProps) => {
  const { asPath, pathname } = useRouter();

  // When an error page is rendered on the server, the pathname will be the error page being rendered and the browser will show the URL of the page that was requested in the address bar.
  // This means that when an error page is rendered, we need to use the pathname to determine the footer props, otherwise we will use the asPath.
  const isErrorPage = pathname === '/404' || pathname === '/500';
  const props = determineFooterProps(isErrorPage ? pathname : asPath);

  return (
    <ServerSafeVisibilitySensor
      intervalCheck={false}
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'value' implicitly has an 'any' type.
      onChange={(value) => actions.footer.setVisibility(value)}
      partialVisibility
      scrollCheck
      scrollDelay={50}
    >
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ acknowledgement: { description: string; image: string; }; appCalloutIcons?: { [key: string]: { image: string; link: string; }; } | undefined; awards: { blurb: string; images: { alt: string; imageSrc: string; label: string; to: string; }[]; }; contacts: { ...; }[]; disclaimer: string; logo: { ...; }; navLinks: NavL...' is not assignable to type 'Partial<Pick<Pick<FooterProps, keyof FooterProps> & Pick<InferProps<{ appCalloutIcons: Requireable<InferProps<{ android: Validator<NonNullable<InferProps<{ image: Requireable<string>; link: Requireable<string>; }>>>; ios: Requireable<...>; }>>; navLinks: Validator<...>; }>, never> & Pick<...>, "className" | ... 1 mo...'. */}
      <Footer {...props} />
    </ServerSafeVisibilitySensor>
  );
};

const mapDispatchToProps = (dispatch?: any) => ({
  actions: {
    footer: bindActionCreators(footerActionCreators, dispatch),
  },
});

export default connect(null, mapDispatchToProps)(FooterWithStaticProps);

export { FooterWithStaticProps, mapDispatchToProps };
